// removed by extract-text-webpack-plugin
module.exports = {"featured_projects":"_7I-ugYZQHIUW7L-A_K1Qf","underline":"DZwm_5lU-s-9J7QESKqwC","wrapper":"_1p24W_jBqS3EvY12HXADz3","featured_image":"LRyK0NpbQinHiF78bqI41","line02":"_3n3S1onKVIyPcG1eie4-Av","line03":"_3G1sRjqbIlgiIWTlKHLgkz","line04":"_1S23BxmLu3MpsuSQoZnljX","line05":"a7Pnst-M1TWaH5cbyMFxZ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FeaturedProjects/FeaturedProjects.module.css
 ** module id = 227
 ** module chunks = 0
 **/